import { render, staticRenderFns } from "./ChemicalPairSplitModal.html?vue&type=template&id=0b4ea6fb&external"
import script from "./ChemicalPairSplitModal.ts?vue&type=script&lang=ts&external"
export * from "./ChemicalPairSplitModal.ts?vue&type=script&lang=ts&external"
import style0 from "./ChemicalPairSplitModal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports